import React from "react";
import Datetime from "react-datetime";
import { usePrecandidateContext } from "../context/Context";
import { useTranslation } from "react-i18next";
import FormInput from "../../../components/FormGroup/FormInput";
import "react-datetime/css/react-datetime.css";
import "./styles.scss";
import "moment/locale/pt";
import "moment/locale/fr";
import "moment/locale/en-gb";
import moment from "moment";

const CreateContact = () => {
  const { t } = useTranslation();
  const { i18n } = useTranslation();
  const {
    errors,
    reasons,
    CreateCandidateInteraction,
    contactavailabilityStatus,
    onChangeContactPreCandidate,
    onChangeNextContactDate,
    onChangeAvailabilityStatusContactPreCandidate,
    contactPreCandidate
  } = usePrecandidateContext();

  function isValidDate(selectedDate) {
    const lastWeek = moment().subtract(8, "days");
    return selectedDate > lastWeek;
  }

  return (
    <form onSubmit={CreateCandidateInteraction}>
      <div className="availability-status">
        {errors.availabilityStatusId && (
          <div className="error-msg">{errors.availabilityStatusId}</div>
        )}
        {contactavailabilityStatus.map((item) => (
          <div className="input-item">
            <input
              type="radio"
              name="formHorizontalRadios"
              id={`formHorizontalRadios${t(item.description)}`}
              value={item.id}
              onChange={(e) => {
                onChangeAvailabilityStatusContactPreCandidate(
                  item.id,
                  item.code
                );
              }}
            />
            <label htmlFor="formHorizontalRadios">{t(item.description)}</label>
          </div>
        ))}
      </div>
      <div className="col-md-12">
        <div className="form-group">
          <div className="label-wrapper">
            <label>{t("Reason")}</label>
            {errors.availabilityReasonId && (
              <div className="error-msg">{errors.availabilityReasonId}</div>
            )}
          </div>
          <select
            id="availabilityReasonId"
            name="availabilityReasonId"
            className="form-select"
            disabled={contactPreCandidate.availabilityStatusCode !== "UN"}
            onChange={onChangeContactPreCandidate}
            defaultValue={0}
            required
            title={t("Selecione um item da lista.")}
            style={{ width: "240px" }}
            value={contactPreCandidate.availabilityReasonId || 0}
          >
            <option key={0} value={0} selected>
              {t("Select Reason...")}
            </option>
            {reasons.map((item) => (
              <option key={item.id} value={item.id}>
                {t(item.description)}
              </option>
            ))}
          </select>
        </div>
      </div>
      <FormInput
        labelText={t("Contact Date")}
        errorMessage={errors.nextContactDate}
      >
        <Datetime
          initialValue={contactPreCandidate.nextContactDate}
          id="nextContactDate"
          name="nextContactDate"
          dateFormat="DD-MM-YYYY"
          onChange={onChangeNextContactDate}
          utc={true}
          isValidDate={isValidDate}
          closeOnSelect={true}
          locale={
            i18n.language === "PT" ? "PT" : i18n.language === "FR" ? "FR" : "EN"
          }
          inputProps={{
            placeholder: t("dd-mm-yyyy"),
            style: { width: "240px" }
          }}
        />
      </FormInput>
      <div className="col-md-12">
        <div className="label-wrapper">
          <label htmlFor="comments">{t("Add a note")}</label>
          {errors.comments && (
            <div className="error-msg">{errors.comments}</div>
          )}
        </div>
        <textarea
          className="form-control"
          id="comments"
          rows="4"
          value={contactPreCandidate.comments}
          onChange={onChangeContactPreCandidate}
          name="comments"
          maxLength="250"
          placeholder={t("Add a note...")}
        />
      </div>
    </form>
  );
};

export default CreateContact;
